import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose, bindActionCreators } from 'redux';

import withAuthGuard from '../withAuthGuard';
import MyAccount from '../../components/MyAccount';
import {
  selectActiveAddOnSubscriptions,
  selectActivePlanSubscription,
  selectIsSubscriptionFromApps,
  selectAccountProducts,
  selectSubscriptionMethodId,
  selectProducts,
  selectPlanToShow
} from '../../queries/selectors/products';
import { selectCurrentContentFichaPath, selectCurrentContentId, selectCurrentContent } from '../../queries/selectors/contents';
import {
  selectSubscriberConfig,
  selectReturnURLPath,
  selectBootstrapConfig,
  selectSubscriptionList,
  selectInvoicesEntities,
  selectSingleSubscriptionClient,
  selectInvoice
} from '../../queries/selectors/bootstrap';
import { requestAsync, mutateAsync } from '../../queries/actions';
import { cleanOrder } from '../../queries/actions/shoppingCart';
import { cancelPlanSubscription, downgradeAddOnSubscriptions, reactivateProducts, upgradeAddOnSubscriptions } from '../../queries/subscription';
import { getAllInvoicesBySubscriber, getInvoicesBySubscriber, getLastInvoiceBySubscriber } from '../../queries/invoice';
import withMembershipGuard from '../withMembershipGuard';
import withMembershipPurchased from '../withMembershipPurchased';
import {
  selectClient,
  selectCancellationMethod,
  selectContentProvider,
  selectAffiliatesUrl,
  selectAddOnsEnabled
} from '../../global-selectors';
import { selectAllSubPaymentMethodsConfig, selectPaymentConfig, selectPaymentMethods } from '../../queries/selectors/payment';
import { selectUserData, selectDeviceCountry, selectUserDeviceToken } from '../../queries/selectors/user';
import { selectCountryCode } from '../../queries/selectors/subscriptions';
import { applyProductRules } from '../../queries/actions/rules';
import { connectRequest } from '../../utils/query';
import {
  getBindingRequest,
  getInitiateBindingSecuredUrlRequest,
  getSubscriberRequest,
  unbindSubscriberMutation
} from '../../queries/affiliates';
import { getMsoConfigRequest } from '../../queries/mso';
import { selectBinding, selectBoundSubscriberUser, selectInitiateBindingSecuredUrl, selectSubscriptionActionConfigs } from '../../queries/selectors/affiliates';
import { selectMsoConfig } from '../../queries/selectors/mso';
import { getAlltransactions } from '../../queries/transactions';

const mapStateToProps = (state) => {
  const contentId = selectCurrentContentId(state);
  const paymentConfig = selectPaymentConfig(state);
  const subPaymentMethods = selectAllSubPaymentMethodsConfig(state);
  const countryCode = selectCountryCode(state);  

  return {
    planToShow: selectPlanToShow(state),
    planSubscription: selectActivePlanSubscription(state),
    addOnSubscriptions: selectActiveAddOnSubscriptions(state),
    allSubscriptions: selectSubscriptionList(state),
    accountProducts: selectAccountProducts(state),
    products: selectProducts(state),
    path: selectReturnURLPath(state) || selectCurrentContentFichaPath(state) + 'my-account',
    subscriber: selectSubscriberConfig(state),
    isSingleSubscriptionClient: selectSingleSubscriptionClient(state),
    isSubscriptionFromApps: selectIsSubscriptionFromApps(state),
    subscriptionMethodId: selectSubscriptionMethodId(state),
    deviceCountry: selectDeviceCountry(state),
    client: selectClient(state),
    user: selectUserData(state),
    cancellationFlow: selectCancellationMethod(state),
    config: selectBootstrapConfig(state),
    paymentConfig,
    subPaymentMethods,
    content: selectCurrentContent(state),
    countryCode,
    subscriberConfig: selectSubscriberConfig(state),
    paymentMethods: selectPaymentMethods(state),
    invoices: selectInvoicesEntities(state),
    invoice: selectInvoice(state),
    contentId,
    // TODO: for affialites
    boundSubscriberUser: selectBoundSubscriberUser(state),
    cp: selectContentProvider(state),
    affiliatesURL: selectAffiliatesUrl(state),
    userDeviceToken: selectUserDeviceToken(state),
    initiateBindingSecuredUrl: selectInitiateBindingSecuredUrl(state),
    binding: selectBinding(state),
    subscriptionActionConfigs: selectSubscriptionActionConfigs(state),
    msoConfig: selectMsoConfig(state),
    isAddOnsEnabled: selectAddOnsEnabled(state)
  }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  cancelPlanSubscription: (data) => requestAsync(cancelPlanSubscription, data),
  getAllInvoicesBySubscriber: (data) => requestAsync(getAllInvoicesBySubscriber, data),
  getInvoices: (data) => requestAsync(getInvoicesBySubscriber, data),
  upgradeAddOnSubscriptions: (data) => requestAsync(upgradeAddOnSubscriptions, data),
  downgradeAddOnSubscriptions: (data) => requestAsync(downgradeAddOnSubscriptions, data),
  reactivateProducts: (data) => requestAsync(reactivateProducts, data),
  cleanOrder: () => cleanOrder(),
  applyProductRules: (data) => applyProductRules(data),
  unbindBinding: (data) => mutateAsync(unbindSubscriberMutation, data),
}, dispatch);

const mapPropsToConfig = (props) => [
  getInitiateBindingSecuredUrlRequest(props),
  getBindingRequest(props),
  getSubscriberRequest(props),
  getMsoConfigRequest(props),
  getAlltransactions(props),
  getLastInvoiceBySubscriber(props)
]

export default compose(
  withAuthGuard({ toLoginURL: true }),
  injectIntl,
  withMembershipGuard,
  withMembershipPurchased,
  connect(mapStateToProps, mapDispatchToProps),
  connectRequest(mapPropsToConfig)
)(MyAccount);
